import { LDFlagsService } from '../ld-flags.service';

export class OrgManagementLDFlags {
  constructor(private ldFlagsService: LDFlagsService) {}

  /***
   *  Team: Admin Experience
   *  Created Date: 09/23/2022 [PD-79275]
   *  Planned Cleanup: TBD (Covert to org setting) [PD-92084]
   *  Visibility:
   *    - Pre-Release: Segments UI
   *    - OrgId (many)
   *
   *  Provides access to view the segments UI via the SegmentsGuard.
   */
  public get segmentsUI(): boolean {
    return this.ldFlagsService.getFlag('segments-ui', false);
  }

  /**
   * Team: Admin Experience
   * Created Date:
   * Planned Cleanup:
   * Visibility:
   *   - Pre-Release: Pre-Release: Dynamic Groups
   */
  public get dynamicGroups(): boolean {
    return this.ldFlagsService.getFlag('manage-exe-segmentgroups', false);
  }

  /**
   * Team: Admin Experience
   * Created Date:
   * Planned Cleanup:
   * Visibility:
   *   - Pre-Release: Pre-Release: exe segments 2
   */
  public get dynamicGroupsV2(): boolean {
    return this.ldFlagsService.getFlag('manage-exe-segmentgroups-part2', false);
  }

  /**
   * Team: API Platform
   * Created Date: 11/04/2024
   * Planned Cleanup: Enable for all the companies, Prod
   * Visibility:
   *  - OrgID: 100364 (enbaled for now)
   *  - User has to be an Org Admin
   *  - Currently active only in staging
   */
  public get showWebhooksAdmin(): boolean {
    return this.ldFlagsService.getFlag('api-enable-outbound-webhooks', false);
  }

  /***
   *  Team: Platform Services
   *  Created Date: 11/04/2024 [PD-109288]
   *  Planned Cleanup: [PD-109289]
   *  Visibility:
   *    - Pre-Release: Custom Roles
   *
   *  Provides access to Custom Roles feature
   */
  public get customRolesEnabled(): boolean {
    return this.ldFlagsService.getFlag(
      'PlatformServices_CustomRolesEnabled',
      false
    );
  }

  public get manageAutomationsMobile(): boolean {
    return this.ldFlagsService.getFlag('manage-automations-mobile', false);
  }

  public get manageCoachBuilder(): boolean {
    return this.ldFlagsService.getFlag('lxp-degreed-coach-builder', false);
  }
}
